<template>
  <div>
    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
        <a
          href="https://www.100ec.cn/enterprise/#/list?field=%E6%95%B0%E5%AD%97%E9%9B%B6%E5%94%AE&category=%E5%85%A8%E9%83%A8"
          target="_blank"
          >更多</a
        >
      </div>

      <Company />
    </div>

    <div class="right-box">
      <div class="right-title">
        <span>人物</span>
      </div>
      <ul class="platform">
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E9%A9%AC%E4%BA%91"
            target="_blank"
            >马云</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%BC%A0%E5%8B%87"
            target="_blank"
            >张勇</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%88%98%E5%BC%BA%E4%B8%9C"
            target="_blank"
            >刘强东</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E9%BB%84%E5%B3%A5"
            target="_blank"
            >黄峥</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E9%9B%B7%E5%86%9B"
            target="_blank"
            >雷军</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%BE%90%E9%9B%B7"
            target="_blank"
            >徐雷</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E8%BE%9B%E5%88%A9%E5%86%9B"
            target="_blank"
            >辛利军</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E6%B2%88%E4%BA%9A"
            target="_blank"
            >沈亚</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%BC%A0%E8%BF%91%E4%B8%9C"
            target="_blank"
            >张近东</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%88%98%E7%82%BD%E5%B9%B3"
            target="_blank"
            >刘炽平</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E8%91%A3%E6%98%8E%E7%8F%A0"
            target="_blank"
            >董明珠</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E4%B8%81%E7%A3%8A"
            target="_blank"
            >丁磊</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E8%92%8B%E5%87%A1"
            target="_blank"
            >蒋凡</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E6%88%B4%E7%8F%8A"
            target="_blank"
            >戴珊</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E9%99%88%E7%9D%BF"
            target="_blank"
            >陈睿</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E7%AC%91%E5%8F%A4"
            target="_blank"
            >笑古</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E5%85%AD%E9%83%8E"
            target="_blank"
            >六郎</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E6%A2%81%E6%98%8C%E9%9C%96"
            target="_blank"
            >梁昌霖</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E9%99%88%E7%90%AA"
            target="_blank"
            >陈琪</a
          >
        </li>
        <li>
          <a
            href="http://www.100ec.cn/Index/wjs_search_res.html?kw=%E4%BE%AF%E6%AF%85"
            target="_blank"
            >侯毅</a
          >
        </li>
      </ul>
    </div>
    <!-- <div class="right-box">
      <div class="right-title">
        <span>合作伙伴</span>
      </div>
      <ul class="partner-list">
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E6%8B%BC%E5%A4%9A%E5%A4%9A"
            target="_blank"
          >
            <img
              src="//imgs-b2b.toocle.com/Public/home/images/DR/logo_pdd.png"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E4%BA%AC%E4%B8%9C"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/logo_jd.png"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E5%B0%8F%E7%B1%B3%E5%95%86%E5%9F%8E"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/xm.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E5%BF%AB%E6%89%8B"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/ks.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E6%8A%96%E9%9F%B3"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/dy.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E5%94%AF%E5%93%81%E4%BC%9A"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/logo_wph.png"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E8%8B%8F%E5%AE%81%E6%98%93%E8%B4%AD"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/logo_sn.png"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E5%BE%97%E7%89%A9APP"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/dw.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E8%BF%94%E5%88%A9%E7%BD%91"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/flw.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E5%AE%9D%E5%AE%9D%E6%A0%91"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/bbs.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E9%80%94%E8%99%8E%E5%85%BB%E8%BD%A6"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/logo_th.png"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E5%A4%A7%E6%90%9C%E8%BD%A6"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/dsc.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E6%A2%A6%E9%A5%B7%E9%9B%86%E5%9B%A2"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/mxjt.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E8%BE%BE%E8%BE%BE"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/ddjt.jpg"
            />
          </a>
        </li>
        <li>
          <a
            href="http://www.100ec.cn/enterprise/#/Inside?name=%E5%A5%87%E9%BA%9F%E9%B2%9C%E5%93%81"
            target="_blank"
          >
            <img
              src="http://imgs-b2b.toocle.com/Public/home/images/DR/qlxp.jpg?v=1.0"
            />
          </a>
        </li>
      </ul>
    </div> -->
    <Email />

    <div class="right-box">
      <div class="right-title">
        <span>热门投诉</span>
        <a href="/Index/complain.html" target="_blank">我要投诉</a>
      </div>

      <ul class="platform">
        <li
          v-for="(i, index) of platform"
          :key="index"
          @click="getPlatform(index)"
        >
          {{ i }}
          <i class="fa fa-fire fa-lg"></i>
        </li>
      </ul>
    </div>
    <div style="width: 365px">
        <img style="width: 100%" src="/Public/tuku/697b242854ed3.jpg" />
    </div>
    <!-- <div style="width: 365px; margin-top: 20px">
      <a>
        <img
          style="width: 100%"
          src="/Public/home/images/zyttk/zytgg/szlst.jpg"
        />
      </a>
    </div> -->
    <!-- <div class="right-box">
      <div class="right-title">
        <span>网经社数字经济台</span>
        <a href="http://DE.100ec.cn/" target="_blank"
          >更多</a
        >
      </div>
      <div style="width: 300px">
        <a href="http://DE.100ec.cn/" target="_blank">
          <img style="width: 100%" src="/Public/home/images/szjj550.jpg" />
        </a>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      activeName: "second",
      params: {
        field: "数字零售",
        tabs: [
          "综合电商",
          "社交电商",
          "社区团购",
          "直播电商",
          "汽车电商",
          "生鲜电商",
          "二手电商",
          "奢侈品电商",
          "食品电商",
          "美妆电商",
          "农村电商",
          "母婴电商",
          "鲜花电商",
          "酒水电商",
          "服装电商",
          "文玩电商",
          "宠物电商",
          "电商服务商",
        ],
      },
      list: [
        "拼多多",
        "京东",
        "小米",
        "快手",
        "抖音",
        "唯品会",
        "苏宁易购",
        "得物APP",
        "返利网",
        "宝宝树",
        "途虎养车",
        "大搜车",
        "梦饷集团",
      ],
      year: "",
      time: "",
      platform: [],
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
  mounted() {
    if (new Date().getMonth >= 2) {
      this.year = new Date().getFullYear();
    } else {
      this.year = new Date().getFullYear() - 1;
      this.time = "whole_year";
    }
    axios
      .get(
        "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=" +
          "&limit=20&year=" +
          this.year +
          "&time=" +
          this.time
      )
      .then((res) => {
        for (var i of res.data.list) {
          this.platform.push(i.company);
        }
      });
  },
  methods: {
    getPlatform(index) {
      window.open(
        "/Index/complain_search.html?company=" + this.platform[index]
      );
    },
  },
};
</script>
<style scoped>
.platform a {
  color: #606266;
}
.partner-list li {
  padding: 8px;
  flex: 0 0 20%;
}
.partner-list img {
  width: 74px;
  border-radius: 2px;
  opacity: 1;
  transition: all 0.3s ease;
}
</style>